import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function ImpressumPage() {
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-578">
      <Navigation data-id="element-579" />
      <main className="pt-24 pb-16" data-id="element-580">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-581">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-582">Impressum</h1>

          <div className="prose prose-invert max-w-none" data-id="element-583">
            <section className="mb-8" data-id="element-584">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-585">
                Adresse
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-586">
                CRM Kraft LLC
                <br data-id="element-587" />
                7901 4th St. N, Ste. 300
                <br data-id="element-588" />
                St. Petersburg, FL 33702
                <br data-id="element-589" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-590">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-591">
                Kontakt
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-592">
                Telefon: +4915735999071
                <br data-id="element-593" />
                E-Mail: justus@crm-kraft.de
              </p>
            </section>

            <section className="mb-8" data-id="element-594">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-595">
                EU-Streitschlichtung
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-596">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-597">
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br data-id="element-598" />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section data-id="element-599">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-600">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-601">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-602" />
    </div>;
}